<template>
	<div class="showcaser">
		<div><img :src="require('@/' + items[selectedIndex].imagePath)" alt=""  class="showcaser__image"/></div>
		<div>
			<slot></slot>
			<ul class="showcaser__items">
				<li v-for="(item, index) in items" class="showcaser__item" :class="{ 'showcaser__item--selected': selectedIndex == index }">
					<a class="showcaser__link" @mouseover="selectedIndex = index">
						<img src="@/assets/check.svg" class="showcaser__icon" />
						<p class="showcaser__description"><span class="u-weight-semibold">{{ item.title }}</span>{{ item.text ? ('&nbsp;-&nbsp;' + item.text) : '' }}</p>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	created () {

	},
	data () {
		return {
			selectedIndex: 0,
		}
	},
	props:{
		items: Array
	}
};
</script>

<style scoped>
.showcaser { display: flex; } 
.showcaser > * { flex: 1; }
.showcaser > *:first-child { margin-right: 40px; }
.showcaser__image { max-height: 600px; max-width: 100%; }
.showcaser__items { list-style: none; display: flex; flex-direction: column; margin-top: 20px; }
.showcaser__item { margin-bottom: 5px; border-radius: 30px; } 
.showcaser__item--selected { box-shadow: 0px 0px 7px #88888845; } 
.showcaser__link { cursor: pointer; padding: 15px 0; display: flex; align-items: center; }
.showcaser__icon { max-width: 40px; height: 30px; margin: 0 20px; }
.showcaser__description { line-height:1; }

@media (max-width: 768px) {
	.showcaser { flex-direction: column-reverse; }
	.showcaser > *:first-child { margin-right: 0; }
}
</style>
